import { NavLink } from "react-router-dom";
const HeaderMenu = ({
  className,
  onClick,
}: {
  className?: string;
  onClick?: any;
}) => {
  return (
    <ul className={`header_menu ${className}`}>

      <li>
        <NavLink to="/" onClick={onClick}>
          Get SBTC
        </NavLink>
      </li>
      <li>
        <NavLink to="/my-activity" onClick={onClick}>
          My Activity
        </NavLink>
      </li>

    </ul>
  );
};
export default HeaderMenu;
